import React, { useEffect, useState } from "react";
import dayjs from 'dayjs';;
import styles from "./meetings.module.scss";
import Images from "assets/Images";

const PerviousMeetings = ({ meetingsData, loading = false, handleOpenMeatingMinutes, onCustomerLink }) => {
    const [value, setValue] = React.useState([dayjs(), dayjs().add(7, 'day')]);
    return (

        <div className={styles.upcomingMeetings}>

            <section className={styles.meetingList}>
                {loading ? (
                    <div className="flex justify-center items-center h-48">
                        <p className={`text-gray-500 text-lg ${styles.gridLoaderContainer}`}>
                            <img src={Images.SPINNER} width="80" alt="Loading..." />
                        </p>
                    </div>
                ) : (
                    <table className="w-full text-left border">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="p-2" width="180">
                                    Topic
                                </th>
                                <th className="p-2" width="180">
                                    Date
                                </th>
                                <th className="p-2" width="180">
                                    Duration
                                </th>
                                <th className="p-2" width="150">
                                    Meeting Id
                                </th>
                                <th className="p-2" width="150">
                                    Organizer
                                </th>

                                {/* <th className="p-2">Score</th> */}
                                <th className="p-2" width="250" >Invitees</th>
                                <th className="p-2" width="100">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {meetingsData.map((meeting) => (
                                <>
                                    <tr key={meeting.id} className="border-t">
                                       <td className="p-2" style={{cursor:'pointer'}} title={meeting.topic}>{meeting.topic.length > 20
                                            ? meeting.topic.substring(0, 20) + "..."
                                            : meeting.topic}</td>
                                        <td className="p-2" >
                                            {meeting.date
                                                ? new Date(meeting.date).toLocaleString("en-US", {
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                })
                                                : "-"}
                                        </td>

                                        <td className="p-2">{meeting.duration}</td>
                                        <td className="p-2">{meeting.meetingId}</td>
                                        <td className="p-2">Organizer &nbsp; </td>
                                        <td className="p-2" style={{cursor:'pointer'}} title={meeting.invitees.join(", ")} >
                                        {meeting.invitees.join(", ").length > 30
                                            ? meeting.invitees.join(", ").slice(0, 30) + "..."
                                            : meeting.invitees.join(", ")}
                                        </td>
                                        <td className="p-2">
                                            <ul className={styles.actionIcons}>
                                                <li>
                                                    <a title="Minutes of Meetings">
                                                        <img src={Images.MEETINGS} alt="Edit" width="14" />
                                                    </a>
                                                </li>
                                                {/* <li>
                              <a
                                onClick={() => {
                                  setSelectedQuestionId(ekyc.id);
                                  handleDeletePopup();
                                }}

                                className="text-red-600 hover:underline"
                              >
                                <img src={Images.TRASH} alt="Delete" width="16" />
                              </a>
                            </li> */}
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr colSpan="6"></tr>
                                </>
                            ))}
                            {
                                meetingsData.length == 0 &&
                                <tr className="border-t">
                                    <td className="p-2" colSpan={7} style={{ textAlign: "center" }}>No data available</td>
                                </tr>
                            }
                            {/* */}
                        </tbody>
                    </table>
                )}
            </section>

        </div>

    );
};

export default PerviousMeetings;
